/**
 * Maps a backend OBJName to the property on the selected row that should
 * prefill that component's bound data-model field.
 *
 * The clicked grid row is stored in Redux (`selectedRowsByDts`); when a subtab
 * screen is assembled, each form field whose OBJName appears here is seeded with
 * `selectedRow[sourceProperty]`. Add an entry per field that needs prefilling.
 */
export const SDUI_FIELD_BINDING: Record<string, string> = {
    LIC_Admin_Details_Inputbox_Name_1: 'licName',
    LIC_Distributor_Details_Inputbox_Name_1: 'licName',
    LIC_Partner_Details_Inputbox_Name_1: 'licName',
    LIC_Client_Details_Inputbox_Name_1: 'licName',
    LIC_Admin_License_Details_Inputbox_Licensor_1: 'licensorName',
    LIC_Admin_License_Details_Inputbox_Licensee_1: 'licenseeName',
    LIC_Admin_User_Details_InputFieldWithAction_Name_1: 'userAccount',
    LIC_Distributor_User_Details_InputFieldWithAction_Name_1: 'userAccount',
    LIC_Distributor_License_Details_Inputbox_Licensor_1: 'licensorName',
    LIC_Distributor_License_Details_Inputbox_Licensee_1: 'licenseeName',
    LIC_Partner_User_Details_InputFieldWithAction_Name_1: 'userAccount',
    LIC_Client_User_Details_InputFieldWithAction_Name_1: 'userAccount',
    LIC_BA_Details_Inputbox_Name_1:
        'businessAdministrationName',
    LIC_BA_User_Details_InputFieldWithAction_UserAccount_1: 'userName',
    LIC_BA_Details_InputFieldWithAction_UserAccount_1: 'userName',
    LIC_Partner_License_Details_Inputbox_Licensor_1: 'licensorName',
    LIC_Partner_License_Details_Inputbox_Licensee_1: 'licenseeName',
    LIC_Client_License_Details_Inputbox_Licensor_1: 'licensorName',
    LIC_Client_License_Details_Inputbox_Licensee_1: 'licenseeName',
}
